import { useSpring, animated } from "@react-spring/web";
const AnimatedDigit = ({
  value,
  animate
}) => {
  const props = useSpring({
    from: {
      transform: animate ? "translateY(15px)" : "translateY(0px)",
      opacity: 0
    },
    to: {
      transform: "translateY(0px)",
      opacity: 1
    },
    config: {
      duration: 650
    },
    // Set duration to 1000ms (1 second) for a slower transition
    reset: animate
  });
  return <animated.span style={props} data-sentry-element="unknown" data-sentry-component="AnimatedDigit" data-sentry-source-file="AnimatedDigit.jsx">{value}</animated.span>;
};
export default AnimatedDigit;